import React, { Component } from 'react'
import { Container, Row, Col, Alert, Button, Table } from 'reactstrap';
import LoggedContext from '../BusinessObjects/LoggedContext'
import ResourceField from '../Models/ResourceField';

import EsaedroLookup from './EsaedroLookup';
import EsaedroResourceFilter from '../Models/EsaedroResourceFilter';
import { themeCol3, themeCol4, themeCol9, themeGroup, themeSpinner, themeFormInput, themeBackButton, themeUpdateButton, themeCol6, themeCol6Right, themeSaveButton } from '../Utils/EsaedroTheme';
import { TableBody, TextField } from '@material-ui/core';

export interface EsaedroFilterConfigProps {
  myObjType: string
  myObjectFields: ResourceField[];
  onReturn?(objectFilters?: EsaedroResourceFilter[], ackMessage?: string): void
}

interface EsaedroFilterConfigState {
  myObjectFilters: EsaedroResourceFilter[];
  myNewFilter: EsaedroResourceFilter;
  errorMessage: string;
  loading: boolean;
}

export default class EsaedroFilterConfig extends Component<EsaedroFilterConfigProps, EsaedroFilterConfigState> {

  // Definisco i range delle mie lookup
  filterTypes = "Text=Testo|Date=Data"
  filterOperators = "Uguale=Uguale|Maggiore=Maggiore|Minore=Minore"
  filterConcat = "AND=And|OR=Or"

  // Bool per impedire l'add filter
  disableAddFilterButton = true

  constructor(props: any) {
    super(props);

    this.state = { 
      myObjectFilters: [],
      myNewFilter: new EsaedroResourceFilter("","",""),
      errorMessage:'',
      loading: false
    };
  }

  // Gestisce i cambiamenti in input e li salva nello stato dell'object, innescando il rendering
  handleChange = (event: any) => {

    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    var name = target.name;
    
    let tempFilter = this.state.myNewFilter;
    if (name == "Campo") tempFilter.FieldName = value
    if (name == "Operatore") tempFilter.Operator = value
    if (name == "Valore") tempFilter.Value = value
    if (name == "Tipo") tempFilter.filterType = value
    if (name == "Concatenazione") tempFilter.previousFilterOperator = value

    this.disableAddFilterButton = !(tempFilter.FieldName != "" && tempFilter.Operator != "" && tempFilter.Value != "" && tempFilter.filterType != "" && tempFilter.previousFilterOperator != "") 
    
    this.setState({
      myNewFilter: tempFilter
    });
  }

  updateFilter = () => {
    this.setState(prevState => ({
      myObjectFilters: [...prevState.myObjectFilters, this.state.myNewFilter],
      myNewFilter: new EsaedroResourceFilter("","","")
    }))
  }
  
  // Esce dai filtri e torna alla lista di oggetti (ObjectList)
  returnToList = () => {
    if (this.props.onReturn!=undefined) {
        this.props.onReturn()
    }
  }

  saveAndReturnToList = () => {
    if (this.props.onReturn!=undefined) {
      this.props.onReturn(this.state.myObjectFilters)
    }
  }

  render() {

    var errorMessage = (this.state.errorMessage>'')? 
    (<Alert color="danger">{this.state.errorMessage}</Alert>)
    : undefined

    if (this.state.loading)
    {
      return (
        <Row className={themeGroup()}>
          <Col className={themeCol9()}>
            <i className={themeSpinner()}></i>  Caricamento...  
          </Col>
        </Row>
      )
    }

    else
    {
      let fieldsValues = ""
      let i = 0
      this.props.myObjectFields.forEach((field: ResourceField) => {
        if (i!=0) fieldsValues+="|"
        fieldsValues+=field.FieldName+"="+field.Field_Label
        i++
      })

      let filtersToRender = this.state.myObjectFilters.map((filter: EsaedroResourceFilter) => {
        return this.renderFilter(filter);
      })

      let savedFiltersLabel = this.state.myObjectFilters.length
                                ?<Row>Filtri applicati</Row>
                                : undefined 

      let valueField = <TextField name="Valore" value={this.state.myNewFilter.Value} onChange={this.handleChange}></TextField>

      if (this.state.myNewFilter.filterType == "Date") 
        valueField = <input className={themeFormInput()} type="date" name="Valore"   value={this.state.myNewFilter.Value} onChange={this.handleChange}/>


      let newFilterFields = 
        <Container>
          <Row className={themeGroup()}>Aggiungi Filtro:</Row>
          <Row className={themeGroup()}>
          <Col className={themeCol6()} required={true}> Campo: </Col>
            <Col className={themeCol6()}>
              <EsaedroLookup 
                  name="Campo" 
                  value={this.state.myNewFilter.FieldName} 
                  fatherObj={""}
                  onChange={this.handleChange}  
                  lookupName="Nome campo"
                  lookupValues={fieldsValues} 
                  displayName="Nome campo">
              </EsaedroLookup>
            </Col>
          </Row>
          <Row className={themeGroup()}>
          <Col className={themeCol6()} required={true}> Tipo: </Col>
            <Col className={themeCol6()}>
              <EsaedroLookup 
                  name="Tipo" 
                  value={this.state.myNewFilter.filterType} 
                  fatherObj={""}
                  onChange={this.handleChange}  
                  lookupName="Tipo campo"
                  lookupValues={this.filterTypes} 
                  displayName="Tipo campo">
              </EsaedroLookup>
            </Col>
          </Row>
          <Row className={themeGroup()}>
            <Col className={themeCol6()} required={true}> Operatore: </Col>
            <Col className={themeCol6()}>
              <EsaedroLookup 
                  name="Operatore" 
                  value={this.state.myNewFilter.Operator} 
                  fatherObj={""}
                  onChange={this.handleChange}  
                  lookupName="Operatore" 
                  lookupValues={this.filterOperators} 
                  displayName="Operatore" >
              </EsaedroLookup>
            </Col>
          </Row>
          <Row className={themeGroup()}>
            <Col className={themeCol6()} required={true}> Tipo concatenazione: </Col>
            <Col className={themeCol6()}>
              <EsaedroLookup 
                  name="Concatenazione" 
                  value={this.state.myNewFilter.previousFilterOperator} 
                  fatherObj={""}
                  onChange={this.handleChange}  
                  lookupName="Concatenazione" 
                  lookupValues={this.filterConcat} 
                  displayName="Concatenazione" >
              </EsaedroLookup>
            </Col>
          </Row>
          <Row className={themeGroup()}>
            <Col className={themeCol6()} required={true}> Valore: </Col>
            <Col className={themeCol6()}>
              {valueField}
            </Col>
          </Row>
          
        </Container>
      

      return (        
          <Container>
            <Row className={themeGroup()}>
              <Col className={themeCol6()}>
              <Button className={themeSaveButton()} size="lg" disabled={this.disableAddFilterButton} onClick={this.updateFilter}><i className="fa fa-plus"></i></Button>
              </Col>
              <Col className={themeCol6Right()}>
                <Button className={themeBackButton()} size="lg" onClick={this.returnToList}><i className="fa fa-close"></i></Button>
              </Col>
            </Row>
            <Row>
                &nbsp;
            </Row>
            {errorMessage}
            {savedFiltersLabel}
            {filtersToRender}
            {newFilterFields}
            <Row className={themeGroup()}>
              <Col className={themeCol6()}>
              <Button className={themeSaveButton()} size="lg" disabled={this.disableAddFilterButton} onClick={this.saveAndReturnToList}><i className="fa fa-save"></i></Button>
              </Col>
            </Row>
          </Container>
      )
    }    
  }

  renderFilter = (filter: EsaedroResourceFilter) => {
                      
    return (
      <tbody>
        <th> Campo </th>
        <th> Operatore </th>
        <th> Tipo </th>
        <th> Valore </th>
        <tr>
          <td>{filter.FieldName}</td>
          <td>{filter.Operator}</td>
          <td>{filter.filterType}</td>
          <td>{filter.Value}</td>
        </tr>
      </tbody>
      
    )
  }

  // Funzione che si occupa di renderizzare ogni singolo campo in base al tipo e ai suoi parametri
  renderField = (field: ResourceField) => {
/*
    // Qui la lista è filtrata a monte in caso di update, va gestita in caso di insert - TODO capire come gestirla
    if (this.props.isNew && !field.Is_Visible && !field.Is_Key && !field.Is_Nullable) return

    // Questi campi non devono mai essere visibili
    if (field.FieldName == 'dat_obsoleto' || 
        field.FieldName == 'cod_utente_cre' || 
        field.FieldName == 'dat_utente_cre' || 
        field.FieldName == 'cod_utente_mod' || 
        field.FieldName == 'dat_utente_mod') return

    if (this.props.isNew && !field.Is_Visible && (field.Is_Key || field.Is_Nullable)) {
      field.Field_Label = "ERRORE - Campo chiave o non nullabile"
      field.Readonly = true
    }

    // Se è di tipo Object List non devo mostrarlo
    if (field.Reffered_Resource_Type == 1 || field.Is_Decode || field.Is_Identity) return

    // Questi campi vanno sempre ignorati e mai visualizzati
    if (field.FieldName == "ts_update" || field.FieldName == "flg_isdeleted" || field.FieldName == "dat_ultvar" || field.FieldName == "customer_ID") return
  
    // Qui scorro i fixed fields per trovare l'elenco dei campi non editabili
    if (this.props.fixedFields) {
      let i : number
      for (i=0; i<this.props.fixedFields.length; i++) {
        if (field.FieldName == this.props.fixedFields[i].field && this.props.fixedFields[i].operator == "=") {
          field.Readonly = true
          break
        }
      }
    }

    // Se è sync o siamo in edit ed è chiave il campo deve essere ReadOnly
    if (field.Is_Syncronized || (field.Is_Key) && !this.props.isNew) field.Readonly = true

    // Se è chiave e non nullabile deve essere obbligatorio
    if (field.Is_Key || !field.Is_Nullable ) field.Required = true

    // Inserisco qui l'eventuale callback
    if (this.props.onCustomRenderField) {
      this.props.onCustomRenderField(this.state.myObject, field)
    }

    var validationError = this.validateField(field)
    // Governa il disable del tasto update
    if (validationError) this.disableUpdateBtn = true

    // Lookup 
    if (field.LookupName|| field.LookupValues)
    {
      return (
        <Row className={themeGroup()}>
          <Col className={themeCol3()}>
            <label htmlFor={field.FieldName}>{field.Field_Label}</label>   
          </Col>
          <Col className={themeCol4()}>
            <EsaedroLookup 
              name={field.FieldName} 
              value={this.state.myObject[field.FieldName]} 
              fatherObj={this.state.myObject}
              onChange={this.handleChange}  
              lookupName={field.LookupName?field.LookupName:''} 
              lookupValues={field.LookupValues?field.LookupValues:''} 
              displayName={field.Field_Label}
              lastEditedField={this.lastEditedField}
              isDisabled={field.Readonly}>
            </EsaedroLookup>
            {validationError}
          </Col>
        </Row>
      )
    }

    // Controllo se è un pdf e nel caso gli assegno il Field_Type 400
    if (field.Field_Type == 22 && field.ContentType == "pdf") field.Field_Type = 400 
    
    // Checkbox
    switch (field.Field_Type) {
      case 1:
      case 2:
        return (
          <Row className={themeGroup()}>
              <Col className={themeCol3()}>
                <label htmlFor={field.FieldName}>{field.Field_Label}</label>  
              </Col>
              <Col className={themeCol9()}>
                <input type="checkbox" className={themeFormInput()} name={field.FieldName} disabled={field.Readonly} checked={this.state.myObject[field.FieldName]} onChange={this.handleChange}/>
                  {validationError}
              </Col>
          </Row>   
        )

      case 4:
      case 15:
      case 33:
        // Datetime
        return (
          <Row className={themeGroup()}>
            <Col className={themeCol3()}>
              <label htmlFor={field.FieldName}>{field.Field_Label}{field.Required?" *":""}</label>   
            </Col>
            <Col className={themeCol9()}>
              <input className={themeFormInput()} type="datetime-local" name={field.FieldName} disabled={field.Readonly} required={field.Required} value={this.state.myObject[field.FieldName]} onChange={this.handleChange}/>    
                 {validationError}
            </Col>
          </Row>
        )
      case 31:
        // Date - Controllare MOMENT
        return (
          <Row className={themeGroup()}>
            <Col className={themeCol3()}>
              <label htmlFor={field.FieldName}>{field.Field_Label}{field.Required?" *":""}</label>   
            </Col>
            <Col className={themeCol9()}>
              <input className={themeFormInput()} type="date" name={field.FieldName} disabled={field.Readonly} required={field.Required} value={this.state.myObject[field.FieldName]} onChange={this.handleChange}/>    
                 {validationError}
            </Col>
          </Row>
        )

      case 400:
        // PDF - Assegnato a monte
        // Creo il component per il PDF
        //return <embed src={`data:application/pdf;base64,${this.state.myObject[field.FieldName]}`}  type="application/pdf" width="100%" height="100%"></embed>
        return ( 
          <Row className={themeGroup()}>
            <Col className={themeCol3()}>
              <label htmlFor={field.FieldName}>{field.Field_Label}{field.Required?" *":""}</label>   
            </Col>
            <Col className={themeCol9()}>
              <EsaedroPDF file={`data:application/pdf;base64,${this.state.myObject[field.FieldName]}`} filename={this.state.myObject.cod_nomefile} />  
              {validationError}
            </Col>
          </Row>
        )
      
      default:
        return (
          <Row className={themeGroup()}>
            <Col className={themeCol3()}>
              <label htmlFor={field.FieldName}>{field.Field_Label}{field.Required?" *":""}</label>   
            </Col>
            <Col className={themeCol9()}>
              <input className={themeFormInput()} type="text" name={field.FieldName} disabled={field.Readonly} required={field.Required} value={this.state.myObject[field.FieldName]} onChange={this.handleChange}/>    
                 {validationError}
            </Col>
          </Row>
        )
    }
  }

  // Valida i campi e genera i messaggi da mostrare in tempo reale sotto al campo stesso
  validateField = (field: ResourceField) => {
    // TODO Lookup
    // Ritorna null se il campo è valido -> governa il tasto update
    // Come gestire la stringa vuota???
    var valueToCheck = this.state.myObject[field.FieldName]
  
    if (field.Is_Key && valueToCheck!==0 && valueToCheck!==false && valueToCheck===undefined) return (
      <Alert color="warning">
        Questo campo è chiave e dunque obbligatorio
      </Alert>
    ) 
    if (!field.Is_Nullable && valueToCheck!==false && valueToCheck!==0 && valueToCheck===undefined) return (
      <Alert color="warning">
        Questo campo non può essere nullo
      </Alert>
    )

    if (field.Required && valueToCheck!==false  && valueToCheck!==0 && (valueToCheck===undefined || valueToCheck=='')) return (
      <Alert color="warning">
        Questo campo è obbligatorio
      </Alert>
    )

    if (valueToCheck) {
      // Controllo la lunghezza
      if (field.Field_Size > 0 && valueToCheck.length > field.Field_Size) return (
        <Alert color="danger">
          Questo campo supera la lunghezza massima consentita
        </Alert>
      )
      //Se è un numero controllo che ci siano solo cifre
      if ((field.Field_Type == 0 || field.Field_Type == 5 || field.Field_Type == 6 || field.Field_Type == 8 || field.Field_Type == 13 ) && isNaN(valueToCheck)) return (
        <Alert color="danger">
          Questo campo deve essere numerico
        </Alert>
      )
    }
    
    return null*/
  }
}
